import { CustomVariable } from '../../features/chat-bot/types/chat-flow.interface';

/**
 * Replaces dynamic variable placeholders (`<span class="param">variable_name</span>`)
 * inside a message with their resolved value from `variables`. Unknown variables
 * are removed. Returns the message untouched when no variables are available.
 *
 * This is the single source of truth for param replacement so every place that
 * renders message HTML (agent messages, feedback blocks, checkbox labels, ...)
 * behaves identically.
 */
export function replaceParamVariables(
  message: string,
  variables: CustomVariable | null | undefined
): string {
  if (!variables) {
    return message;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(message, 'text/html');
  const spans = doc.querySelectorAll('span.param');

  spans.forEach((span) => {
    const variableName = span.textContent?.trim();
    if (variableName && variables.hasOwnProperty(variableName)) {
      span.replaceWith(variables[variableName]);
    } else {
      span.remove();
    }
  });

  return doc.body.innerHTML;
}
